
    import React from 'react';
    import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "icon-chevron-down-24_wPhNK",
  "use": "icon-chevron-down-24_wPhNK-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-chevron-down-24_wPhNK\">\n<g transform=\"translate(5 9)\">\n<path d=\"M7.00003 4.69832L1.64021 0.231804C1.21593 -0.12176 0.585368 -0.0644364 0.231804 0.35984C-0.12176 0.784117 -0.0644362 1.41468 0.359841 1.76825L6.35984 6.76825C6.73069 7.07728 7.26936 7.07728 7.64021 6.76825L13.6402 1.76825C14.0645 1.41468 14.1218 0.784117 13.7682 0.35984C13.4147 -0.0644364 12.7841 -0.12176 12.3598 0.231804L7.00003 4.69832Z\" />\n</g>\n</symbol>"
});
    sprite.add(symbol);

    const IconChevronDown_24WPhNkSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "icon-chevron-down-24_wPhNK", width: 24, height: 24, ...props })
    }

    export { IconChevronDown_24WPhNkSpriteSymbolComponent as ReactComponent };
  